import { Link } from "react-router-dom";
import Header from "../../components/feature/Header";
import Footer from "../../components/feature/Footer";
import PageSEO from "../../components/feature/PageSEO";

const images = [
  {
    src: "https://readdy.ai/api/search-image?query=sleek%20modern%20Silicon%20Valley%20tech%20office%20interior%20with%20open%20plan%20workspace%2C%20floor-to-ceiling%20glass%20walls%20overlooking%20a%20sunny%20California%20landscape%2C%20pristine%20white%20walls%2C%20polished%20concrete%20floors%2C%20lush%20greenery%20and%20potted%20plants%2C%20warm%20California%20sunlight%20streaming%20in%2C%20minimalist%20contemporary%20furniture%20in%20warm%20white%20and%20natural%20wood%20tones%2C%20airy%20and%20inspiring%20atmosphere%2C%20no%20people%2C%20ultra%20high%20quality%20professional%20architectural%20interior%20photography&width=800&height=500&seq=sv-origin-01&orientation=squarish",
    alt: "Airdog founded in Silicon Valley — modern tech office interior",
  },
  {
    src: "https://readdy.ai/api/search-image?query=sleek%20contemporary%20open-concept%20premium%20retail%20showroom%20interior%20with%20pristine%20white%20walls%2C%20polished%20light%20wood%20floors%2C%20large%20floor-to-ceiling%20windows%20flooding%20the%20space%20with%20soft%20natural%20daylight%2C%20minimalist%20product%20display%20shelves%20with%20clean%20airy%20spacing%2C%20lush%20indoor%20potted%20plants%2C%20warm%20neutral%20tones%20of%20white%20cream%20and%20natural%20wood%2C%20calm%20sophisticated%20commercial%20atmosphere%2C%20no%20people%2C%20ultra%20high%20quality%20professional%20architectural%20interior%20photography&width=800&height=500&seq=retail-clean-match-07&orientation=squarish",
    alt: "Airdog trusted by global premium retailers and luxury department stores",
  },
  {
    src: "https://readdy.ai/api/search-image?query=elegant%20modern%20German%20school%20classroom%20or%20medical%20facility%20interior%20with%20pristine%20white%20walls%2C%20large%20floor-to-ceiling%20windows%20flooding%20the%20room%20with%20bright%20natural%20daylight%2C%20minimalist%20Bauhaus-inspired%20furniture%2C%20clean%20geometric%20lines%2C%20lush%20indoor%20plants%2C%20warm%20neutral%20tones%20of%20white%20grey%20and%20light%20oak%20wood%2C%20highly%20polished%20floors%2C%20sophisticated%20and%20calm%20atmosphere%2C%20no%20people%2C%20ultra%20high%20quality%20professional%20architectural%20interior%20photography&width=800&height=500&seq=de-precision-01&orientation=squarish",
    alt: "Airdog deployed across German schools and medical facilities",
  },
  {
    src: "https://readdy.ai/api/search-image?query=modern%20international%20airport%20terminal%20interior%20with%20high%20ceilings%20and%20floor-to-ceiling%20glass%20walls%2C%20sleek%20minimalist%20design%20with%20clean%20white%20surfaces%20and%20warm%20natural%20wood%20accents%2C%20bright%20natural%20daylight%20streaming%20through%20giant%20windows%2C%20%20passengers%20walking%20in%20blurred%20motion%2C%20contemporary%20architectural%20interior%20photography%20with%20sophisticated%20calm%20atmosphere%2C%20neutral%20tones%20of%20white%20beige%20and%20warm%20grey%2C%20clean%20professional%20atmosphere%2C%20ultra%20high%20quality%20professional%20architectural%20interior%20photography&width=800&height=500&seq=japan-airport-terminal&orientation=squarish",
    alt: "Airdog protects air quality at major Japan airports",
  },
];

const cardData = [
  {
    label: "Founded 2007 — Silicon Valley",
    labelColor: "text-red-600",
    bgColor: "bg-red-50",
    borderColor: "border-red-100",
    text: "Founded in Silicon Valley in 2007, Airdog was born to disrupt the status quo. We pioneered Airdog TPA® technology to eliminate the waste and limitations of traditional HEPA filters. By replacing costly, landfill-bound disposables with a washable, reusable system that never loses efficiency, we deliver pure, sanitized air without compromise.",
  },
  {
    label: "Trusted by Global Brands & Premium Retailers",
    labelColor: "text-amber-600",
    bgColor: "bg-amber-50",
    borderColor: "border-amber-100",
    text: "From medical facilities and schools to Japan's elite department stores like Takashimaya and Daimaru, the world's top venues choose Airdog. Engineered for high-traffic environments, we deliver continuous, active air sanitation—keeping luxury spaces and essential institutions safe, fresh, and welcoming for thousands daily.",
  },
  {
    label: "German Precision: The Gold Standard",
    labelColor: "text-emerald-600",
    bgColor: "bg-emerald-50",
    borderColor: "border-emerald-100",
    text: "Chosen by German medical and educational experts, Airdog protects high-traffic environments across more than 6,000 schools and medical facilities. Adhering to the world's most rigorous industrial benchmarks, our technology is validated by international safety bodies, certified ozone-safe, and proven to maintain 99.9% bio-aerosol destruction under continuous operation.",
  },
  {
    label: "Trusted at Major Japan Airports",
    labelColor: "text-slate-600",
    bgColor: "bg-slate-50",
    borderColor: "border-slate-100",
    text: "Airdog protects air quality at Haneda, Narita, Kansai, and Itami airports, ensuring clean, safe breathing for millions of travelers. Our medical-grade TPA technology operates continuously in the world's busiest terminals, providing active air sanitation without the burden of disposable filter replacements.",
  },
];

const storyJsonLd = {
  "@context": "https://schema.org",
  "@type": "AboutPage",
  "name": "Our Story — Airdog | From Silicon Valley to Global Airports",
  "description": "Discover how Airdog went from a Silicon Valley startup in 2007 to protecting air quality in major Japan airports, German schools, and premium retailers worldwide.",
};

export default function StoryPage() {
  return (
    <div className="min-h-screen flex flex-col">
      <PageSEO jsonLd={storyJsonLd} />
      <Header />

      <main className="pt-16 bg-white">
        {/* Compact Hero */}
        <section className="py-4 md:py-5 bg-white">
          <div className="mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl w-full">
            <div className="text-center mb-4 md:mb-5">
              <span className="inline-block text-[10px] font-bold tracking-[0.2em] uppercase text-red-600 mb-1.5">
                Our Story
              </span>
              <h1 className="text-lg md:text-xl lg:text-2xl font-extrabold text-gray-900 leading-tight mb-1.5">
                Born in Silicon Valley. Trusted Worldwide.
              </h1>
              <p className="text-[11px] md:text-xs text-gray-600 font-bold max-w-2xl mx-auto">
                From California startups to German medical facilities, Tokyo luxury retailers, and Japan&apos;s busiest airports.
              </p>
            </div>
          </div>
        </section>

        {/* Story Cards — horizontal layout for compact height */}
        <section className="relative pb-6 md:pb-8 bg-white">
          <div className="mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl w-full">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-3">
              {images.map((img, i) => (
                <div key={i} className={`flex flex-row gap-2.5 items-start rounded-lg p-2.5 md:p-3 border ${cardData[i].bgColor} ${cardData[i].borderColor} hover:shadow-sm transition-shadow duration-200`}>
                  <div className="w-20 h-20 sm:w-24 sm:h-24 shrink-0 overflow-hidden rounded-md bg-gray-50">
                    <img
                      src={img.src}
                      alt={img.alt}
                      title={img.alt}
                      className="w-full h-full object-cover object-center"
                    />
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className={`text-[10px] font-bold tracking-widest uppercase mb-1 ${cardData[i].labelColor}`}>
                      {cardData[i].label}
                    </p>
                    <p className="text-[11px] md:text-xs leading-snug text-gray-700 line-clamp-3">
                      {cardData[i].text}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Compact CTA */}
        <section className="py-5 md:py-6 bg-brand">
          <div className="mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl text-center">
            <h2 className="text-base md:text-lg font-extrabold text-white mb-1">
              Join the Global Airdog Family
            </h2>
            <p className="text-[11px] text-white/80 font-medium mb-3 max-w-lg mx-auto">
              Experience the same medical-grade air purification trusted worldwide.
            </p>
            <div className="flex flex-col sm:flex-row gap-2 justify-center">
              <Link
                to="/"
                className="rounded-lg font-semibold transition-all duration-200 active:scale-[0.98] inline-block text-center bg-white text-brand hover:bg-white/90 text-[11px] px-4 py-2"
              >
                Explore Products
              </Link>
              <Link
                to="/models"
                className="rounded-lg font-semibold transition-all duration-200 active:scale-[0.98] inline-block text-center border-2 border-white text-white hover:bg-white hover:text-brand text-[11px] px-4 py-2"
              >
                View Models
              </Link>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}